var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fill: "rgb(0,0,0)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m4.93934 20.9393c.58579-.5857 1.53553-.5857 2.12132 0l2.93934 2.9394 2.9393-2.9394c.5858-.5857 1.5356-.5857 2.1214 0 .5857.5858.5857 1.5356 0 2.1214l-4 4c-.5858.5857-1.53557.5857-2.12136 0l-4-4c-.58579-.5858-.58579-1.5356 0-2.1214z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m10 4.5c.8284 0 1.5.67157 1.5 1.5v20c0 .8284-.6716 1.5-1.5 1.5-.82843 0-1.5-.6716-1.5-1.5v-20c0-.82843.67157-1.5 1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m20.9393 4.93934c.5858-.58579 1.5356-.58579 2.1214 0l4 4c.5857.58579.5857 1.53556 0 2.12136-.5858.5857-1.5356.5857-2.1214 0l-2.9393-2.93938-2.9393 2.93938c-.5858.5857-1.5356.5857-2.1214 0-.5857-.5858-.5857-1.53557 0-2.12136z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m22 4.5c.8284 0 1.5.67157 1.5 1.5v20c0 .8284-.6716 1.5-1.5 1.5s-1.5-.6716-1.5-1.5v-20c0-.82843.6716-1.5 1.5-1.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.48dff3d3.svg";
export { ForwardRef as ReactComponent };